// Minimal toast notifications: bottom-right, auto-dismiss, stacking.
let container: HTMLElement | null = null;

export type ToastKind = "info" | "ok" | "warn";

export function toast(message: string, kind: ToastKind = "info", ttlMs = 3200): void {
  if (!container) {
    container = document.createElement("div");
    container.className = "toast-container";
    document.body.append(container);
  }
  const el = document.createElement("div");
  el.className = `toast toast-${kind}`;
  el.textContent = message;
  container.append(el);
  requestAnimationFrame(() => el.classList.add("show"));
  window.setTimeout(() => {
    el.classList.remove("show");
    window.setTimeout(() => el.remove(), 300);
  }, ttlMs);
}
